import { isRejectedWithValue } from '@reduxjs/toolkit'

import { setError, setFeedback } from '../container/home'

const isQuery = action => action?.meta?.arg?.type === 'query'
const isMutation = action => action?.meta?.arg?.type === 'mutation'
const isQueryTriggeredFromUser = action =>
  isQuery(action) && typeof action?.meta?.arg?.forceRefetch === 'boolean'

export const errorMiddleware = api => next => action => {
  if (isRejectedWithValue(action)) {
    const errorMessage =
      action?.payload?.data?.message ||
      action?.payload?.message ||
      action?.error?.message ||
      'Errore!'

    if (isMutation(action) || isQueryTriggeredFromUser(action)) {
      api.dispatch(setFeedback({ phrase: errorMessage, error: true }))
    } else {
      api.dispatch(setError(errorMessage))
    }
  }

  return next(action)
}
